import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["name"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapKeys, reduce } from '@beef/utils';
import { AutoMetricBlockType } from "./constants";
export var serializeContextData = function serializeContextData(targetNode, eventTarget) {
  var _eventTarget$element, _eventTarget$element2;
  var result = {
    target: _objectSpread(_objectSpread({}, eventTarget ? {
      name: eventTarget.name,
      href: (_eventTarget$element = eventTarget.element) === null || _eventTarget$element === void 0 ? void 0 : _eventTarget$element.href,
      text: (_eventTarget$element2 = eventTarget.element) !== null && _eventTarget$element2 !== void 0 && _eventTarget$element2.innerText ? eventTarget.element.innerText.substring(0, 128) : undefined
    } : {}), {}, {
      type: targetNode.type
    })
  };
  var node = targetNode;
  while (node) {
    /* пропускаем данные дочернего узла, если он один и мы уже их выводили */
    var skipChildrenInfo = node !== targetNode && node.children.size === 1;
    result[node.type] = _objectSpread(_objectSpread(_objectSpread({}, result[node.type]), skipChildrenInfo ? {} : serializeNodeChildrenData(node)), serializeNodeData(node));
    node = node.parent;
  }
  return result;
};
export var serializeNodeData = function serializeNodeData(node) {
  return Object.fromEntries(_toConsumableArray(node.fields).map(function (field) {
    return [field.name, field.value];
  }));
};
var isValidString = function isValidString(str) {
  return !!str && typeof str === 'string';
};
var firstLetterLower = function firstLetterLower(str) {
  return isValidString(str) ? str[0].toLowerCase() + str.substring(1) : str;
};
var firstLetterUpper = function firstLetterUpper(str) {
  return isValidString(str) ? str[0].toUpperCase() + str.substring(1) : str;
};
export var prefixElementFields = function prefixElementFields(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'element' : _ref$name,
    fields = _objectWithoutProperties(_ref, _excluded);
  return mapKeys(fields, function (fieldName) {
    return "".concat(firstLetterLower(name)).concat(firstLetterUpper(fieldName));
  });
};
var serializeNodeChildrenData = function serializeNodeChildrenData(node) {
  return Array.from(node.children).filter(function (child) {
    return child.type === AutoMetricBlockType.ELEMENT;
  }).map(serializeNodeData).reduce(function (accum, item) {
    return mergeDuplicateDefinitions(accum, prefixElementFields(item));
  }, {});
};

/**
 * Если поля уже были в объекте, создает множественную форму ключа и добавляет элементы в нее,
 *   например,
 *   { tabId: "one" } + { tabId: "two" } => { tabIds: "one|two" }
 *   { tabIds: "one|two" } + { tabId: "three" } => { tabIds: "one|two|three" }
 */
var mergeDuplicateDefinitions = function mergeDuplicateDefinitions(original, added) {
  return reduce(added, function (accum, value, key) {
    var pluralKey = pluralOf(key);
    if (typeof accum[pluralKey] !== 'undefined') {
      accum[pluralKey] = "".concat(accum[pluralKey], "|").concat(value);
    } else if (typeof accum[key] !== 'undefined') {
      accum[pluralKey] = "".concat(accum[key], "|").concat(value);
      delete accum[key];
    } else {
      accum[key] = value;
    }
    return accum;
  }, original);
};
var pluralOf = function pluralOf(str) {
  // Оканчивается на -s, -x, -z, -ch, -sh
  if (/([sxz]|ch|sh)$/i.test(str)) return "".concat(str, "es");
  // Оканчивается на -y после константы
  if (/[b-df-hj-np-tv-z]y$/i.test(str)) return "".concat(str.replace(/y$/i, 'ies'));
  // Все остальные варианты
  return "".concat(str, "s");
};